$(function() {
  console.log("custom ready!!!");

    console.log("first_request", first_request);
    
    if(request_host.includes('navala.com.co') && request_path !== '/pages/home-naval' && first_request == ""){
      console.log("navala.com.co");

      let attributes = {
        attributes: {
          first_request: "true"
        }
      };

      console.log("redirect");
      location.href = '/pages/home-naval';

      /*
      updateCartAttribute(attributes, function(data){
        console.log(data);
        location.href = '/pages/home-naval';
      });
      */
    }

    $(document).on('click', '.remove_all_items', function(){
        $("body").addClass("loading");
        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function(cart) {
                $("body").removeClass("loading");
                location.reload();
            }
        });
    });

});


    // Selecciona todos los botones para abrir modales
const botonesModal1 = document.querySelectorAll('.boton-modal');

// Agrega un evento click a cada botón
botonesModal1.forEach(boton => {
  boton.addEventListener('click', () => {
    const modal = document.querySelector(boton.dataset.modal); // Encuentra el modal correspondiente al botón
    modal.classList.add('mostrar'); // Agrega la clase "mostrar" para mostrar el modal
  });
});

// Selecciona todos los botones para cerrar modales
const botonesCerrar1 = document.querySelectorAll('.modal-cerrar');

// Agrega un evento click a cada botón
botonesCerrar1.forEach(boton => {
  boton.addEventListener('click', () => {
    const modal = boton.closest('.modal-custom'); // Encuentra el modal más cercano al botón
    modal.classList.remove('mostrar'); // Quita la clase "mostrar" para ocultar el modal
  });
});

// Cierra el modal si se hace clic fuera del contenido
window.addEventListener('click', evento => {
  const modales = document.querySelectorAll('.modal-custom');
  modales.forEach(modal => {
    if (evento.target === modal) {
      modal.classList.remove('mostrar');
    }
  });
});

// Cierra el modal si se presiona la tecla Esc
window.addEventListener('keydown', evento => {
  const modales = document.querySelectorAll('.modal-custom');
  modales.forEach(modal => {
    if (evento.key === 'Escape') {
      modal.classList.remove('mostrar');
    }
  });
});
